import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { getDateFormatYMD } from "../home/logic";

const initialState = {
  startDate: "",
  endDate: "",
  id: '',
};
const Seeker = ({ searchTeacherReports }) => {
  const [seekerParams, setSeekerParams] = useState(initialState);
  
  useEffect(() => {
    setSeekerParams({
      startDate: getDateFormatYMD(),
      endDate: getDateFormatYMD(),
      id: '',
    })
    

  },[])
  
  const handleOnChange = (e) => {
    setSeekerParams({ ...seekerParams, [e.target.name]: e.target.value });
  };
  const handleClean = () => {
    setSeekerParams(initialState);
  };
  const handleSearch = () => {
    const smsError = isValid();
    if (smsError === true) {
      searchTeacherReports(seekerParams);
    }else{
      toast.error(smsError);
    }
  };

  const isValid = () => {
    const { startDate, endDate, ci } = seekerParams;
    if(startDate > endDate){
      return 'Fechas incorrectas' 
    }
    return true;
  };

  return (
    <div>
      <div className="seeker">
        <div className="seeker__inputs">
          <div className="seeker__input">
            <label htmlFor="">Fecha Inicio</label>
            <Form.Control
              type="date"
              name="startDate"
              value={seekerParams.startDate}
              onChange={handleOnChange}
            />
          </div>
          <div className="seeker__input">
            <label htmlFor="">Fecha Fin</label>
            <Form.Control
              type="date"
              name="endDate"
              value={seekerParams.endDate}
              onChange={handleOnChange}
            />
          </div>
        </div>

        <div className="seeker__btns">
          <Button variant="blue" onClick={handleSearch}>
            Buscar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Seeker;
